import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { http } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { log } from "@/lib/logger";

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // React Router's location.hash is the reactive source of truth here (window.location.hash
    // is not reactive after history.replaceState — using it can leave the callback stuck).
    const params = new URLSearchParams(location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { nav("/login"); return; }

    (async () => {
      try {
        const { data } = await http.post("/auth/google-session", {}, {
          headers: { "X-Session-ID": sessionId },
        });
        if (data.session_token) {
          // Backup for the /auth/me bearer path — cookie is the primary
          // session store, per Emergent Auth playbook.
          localStorage.setItem("proxijob_token", data.session_token);
        }
        setUser(data.user);
        window.history.replaceState(null, "", "/map");
        nav("/map");
      } catch (e) {
        log.error("[AuthCallback]", e);
        nav("/login");
      }
    })();
  }, [nav, setUser, location.hash]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 rounded-full border-4 border-[#1E3A8A] border-t-transparent animate-spin" />
        <p className="text-slate-600 text-sm">Connexion en cours…</p>
      </div>
    </div>
  );
}
